export default function (filePath, params = {}, placeholder = 'placeholder-img.jpg') {
  const generateUrl = (filePath2, params2) => {
    if (!_.isEmpty(params2)) {
      return `${window.aws.cdnPath}/${filePath2}?${$.param(params2)}`;
    }

    return `${window.aws.cdnPath}/${filePath2}`;
  };

  if (_.isEmpty(filePath)) {
    if (placeholder) {
      return generateUrl(placeholder, params);
    }

    return '';
  }

  if (typeof window.aws === 'undefined' || typeof window.aws.cdnPath === 'undefined') {
    console.error('window.aws.cdnPath not set!');
  }

  return generateUrl(filePath, params);
}
